import { useAvailableApps } from 'modules/app-registry/hooks/useAvailableApps'
import { useWindowStore } from 'modules/desktop/pages/MainPage/stores'
import { useLocation } from 'react-router-dom'
import { AppConfig } from 'shared/types/app'

export const useActiveApp = (): {
  app: AppConfig
  type: 'window' | 'detached'
} | null => {
  const { apps } = useAvailableApps()

  const location = useLocation()
  const activeWindowId = useWindowStore(state => state.activeWindowId)

  const activeWindowApp = Object.values(apps).find(
    app => app.id === activeWindowId
  )

  if (activeWindowApp) {
    return {
      app: activeWindowApp,
      type: 'window'
    }
  }

  const activeDetachedApp = Object.values(apps).find(app =>
    location.pathname.startsWith(app.path)
  )

  if (activeDetachedApp) {
    return {
      app: activeDetachedApp,
      type: 'detached'
    }
  }

  return null
}
